import { create } from "zustand";
export const useCanvasTilesStore = create((set, get) => ({
  tiles: [],
  setTiles: tiles => new Promise((resolve) => {
    set({ tiles });
    resolve();
  }),
  containerStyles: {},
  setContainerStyles: containerStyles => set({ containerStyles }),
  shown: false,
  setShown: (shown) => set({ shown }),
}))